import { useEffect } from 'react';
import { DatePicker, Form, Modal } from 'antd';
import { useGetChildActivityTypesQuery } from '@/services/general-api';
import { useAddChildActivityMutation } from '@/services/child-api';
import moment from 'moment';
import Select from '@/components/select';

const AddModal = ({ childId, open, refetch, onClose }) => {
  const { data: typeData, isLoading: loadingTypeData } = useGetChildActivityTypesQuery();
  const [addActivity, { isLoading: adding }] = useAddChildActivityMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (values) => {
    try {
      await addActivity({
        childId,
        body: {
          activity: {
            start: values.date.toISOString(),
          },
          type: { id: values.typeId },
        },
      }).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Add Activity"
      open={open}
      okText="Add"
      confirmLoading={adding}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="typeId" label="Type" rules={[{ required: true }]}>
          <Select options={typeData} loading={loadingTypeData} showSearch />
        </Form.Item>
        <Form.Item name="date" label="Date" rules={[{ required: true }]}>
          <DatePicker
            format="MM/DD/YYYY"
            onBlur={(e) => {
              const inputVal = e.target.value;
              const validDate = moment(inputVal, ['M/D/YYYY', 'MM/DD/YYYY'], true);
              if (validDate.isValid()) {
                form.setFieldsValue({
                  date: validDate,
                });
              } else {
                form.setFieldsValue({
                  date: null,
                });
              }
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddModal;
